import React from "react"
import styled from "styled-components"
import {Grid, Row, Col} from "react-bootstrap"

import Card from "@irati/ui/src/Layout/Card"
import {H2} from "@irati/ui/src/Typography/Heading/index"
import media from "@irati/ui/src/global/media"

import ghost from "@irati/ui/images/circle_ghost.svg"
import logo from "@irati/ui/images/logo-alt.svg"
import Link from "@irati/ui/src/Link"

const Picture = styled.img`
  width: 100px;
  height: 100px;
  border: none;
  position: relative;
  margin: -100px auto 0;
`

const StyledCard = styled(Card)`
  text-align: center;
  width: 70%;
  margin: 100px auto 100px auto;
  ${media.tablet`
      width: initial
    `}
`

const Logo = styled.img`
  width: 80px;
  height: 25px;
`

const StyledHeading = styled(H2)`
  margin: 20px 0 40px 0;
  ${media.phone`
      font-size: 35px;
   `}
`

const P = styled.p`
  margin-bottom: 50px;
`

const StyledGrid = styled(Grid)`
  background-color: ${({theme}) => theme.colors.greys.graphGrey};
  min-height: 100%;
`

const Maintenance = () => {
  return (
    <StyledGrid fluid>
      <Row>
        <Col md={12}>
          <StyledCard large>
            <Picture src={ghost} alt="sad ghost" />
            <StyledHeading>Sorry, we are down for maintenance</StyledHeading>
            <P>We expect to be back shortly. Thank you for your patience.</P>
            <P>
              <Link href="https://status.perkbox.com/">Status page</Link>
            </P>
            <Logo src={logo} alt="Perkbox logo" />
            <br />
            <a href="mailto:help@perkbox.co.uk">help@perkbox.co.uk</a>
          </StyledCard>
        </Col>
      </Row>
    </StyledGrid>
  )
}

export default Maintenance
